<template>
  <div class="w-100 h-100">
    <h3>Microscopy Review</h3>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" aria-current="page">
          <b-link :to="{ name: 'microscopy-review-list' }">Microscopy Review List</b-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ bloodslide_code }}</li>
      </ol>
    </nav>
    <b-row>
      <b-col>
        <h4 class="text-center">Read 1</h4>
        <b-table striped hover :fields="fields" :items="read1" :tbody-tr-class="rowClass">
          <template v-slot:cell(current_value)="data">
            <div v-if="data.item.incorrect == true && data.item.type != 'calculated'">
                <!-- Single Select -->
                <b-form-select v-if="data.item.type == 'select'" @change="update_changes(read1, 'r1_')" v-model="data.item.current_value" :options="data.item.options"></b-form-select>

                <!-- Multi Select -->
                <b-form-checkbox-group v-if="data.item.type == 'multi-select'" @change="update_changes(read1, 'r1_')" v-model="data.item.current_value" :options="data.item.options"></b-form-checkbox-group>

                <!-- Integer -->
                <b-form-input v-if="data.item.type == 'integer'" @change="update_changes(read1, 'r1_')" v-model="data.item.current_value" type="number"></b-form-input>

                <!-- Decimal -->
                <b-form-input v-if="data.item.type == 'decimal'" @change="update_changes(read1, 'r1_')" v-model="data.item.current_value" type="number" step="any"></b-form-input>
            </div>
            <div v-else>
              {{ data.value }}
            </div>
          </template>

          
        </b-table>
      </b-col>
      <b-col>
        <h4 class="text-center">Read 2</h4>
        <b-table striped hover :fields="fields" :items="read2" :tbody-tr-class="rowClass">

          <template v-slot:cell(current_value)="data">
            <div v-if="data.item.incorrect == true && data.item.type != 'calculated'">
              <!-- Single Select -->
              <b-form-select v-if="data.item.type == 'select'" @change="update_changes(read2, 'r2_')" v-model="data.item.current_value" :options="data.item.options"></b-form-select>

              <!-- Multi Select -->
              <b-form-checkbox-group v-if="data.item.type == 'multi-select'" @change="update_changes(read2, 'r2_')" :name="'read1_'+data.item.index" v-model="data.item.current_value" :options="data.item.options"></b-form-checkbox-group>

              <!-- Integer -->
              <b-form-input v-if="data.item.type == 'integer'"  @change="update_changes(read2, 'r2_')" v-model="data.item.current_value" type="number"></b-form-input>

              <!-- Decimal -->
              <b-form-input v-if="data.item.type == 'decimal'" @change="update_changes(read2, 'r2_')" v-model="data.item.current_value" type="number" step="any"></b-form-input>
          </div>
            <div v-else>
              {{ data.value }}
            </div>
          </template>

        </b-table>
      </b-col>
      <b-col v-if="read3_enabled == true">

      <h4 class="text-center">Read 3</h4>
        <b-table striped hover :fields="fields" :items="read3" :tbody-tr-class="rowClass">
            <template v-slot:cell(current_value)="data">
              <div v-if="data.item.incorrect == true && data.item.type != 'calculated'">
              <!-- Single Select -->
              <b-form-select v-if="data.item.type == 'select'" @change="update_changes(read3, 'r3_')" v-model="data.item.current_value" :options="data.item.options"></b-form-select>

              <!-- Multi Select -->
              <b-form-checkbox-group v-if="data.item.type == 'multi-select'" @change="update_changes(read3, 'r3_')" :name="'read1_'+data.item.index" v-model="data.item.current_value" :options="data.item.options"></b-form-checkbox-group>

              <!-- Integer -->
              <b-form-input v-if="data.item.type == 'integer'" @change="update_changes(read3, 'r3_')" v-model="data.item.current_value" type="number"></b-form-input>

              <!-- Decimal -->
              <b-form-input v-if="data.item.type == 'decimal'" @change="update_changes(read3, 'r3_')" v-model="data.item.current_value" type="number" step="any"></b-form-input>
              </div>
              <div v-else>
              {{ data.value }}
            </div>
            </template>
        </b-table>
      </b-col>
    </b-row>
    <b-table striped hover :fields="final_fields" borderless :items="final_items">
    </b-table>
    <hr />
    <div class="text-danger" v-if="conflict != null">{{ conflict }}</div>
    <div class="text-danger" v-if="qualitative_conflict != null">{{ qualitative_conflict }}</div>
    <div class="text-danger" v-if="gametocytes_seen_conflict != null">{{ gametocytes_seen_conflict }}</div>
    <b-button class="float-right btn-success mr-4" v-if="save_status == false && conflict == null && qualitative_conflict == null && gametocytes_seen_conflict == null" @click="save_changes">Save Changes</b-button>
    <b-button class="float-right btn-success mr-4" v-if="save_status == false && (conflict != null || qualitative_conflict != null || gametocytes_seen_conflict != null)" disabled>Save Changes</b-button>
    <b-button class="float-right btn-success mr-4" v-if="save_status == true && conflict == null && qualitative_conflict == null && gametocytes_seen_conflict == null" disabled><i class="fa fa-spinner fa-spin"></i> Saving...</b-button>

    <b-button class="float-right btn-danger mr-4" v-if="reread_status == false" @click="reread">Mark For Re-Read</b-button>
    <b-button class="float-right btn-danger mr-4" v-if="reread_status == true" disabled><i class="fa fa-spinner fa-spin"></i> Sending Reread Status...</b-button>
    
  </div>
</template>

<script>
import { HTTP } from "@/utilities/http-common";
import HandleErrors from "@/utilities/handle-errors";

import DashboardBaseTemplate from "@/layouts/DashboardBaseTemplate.vue";

export default {
  mixins: [DashboardBaseTemplate],
  data: function() {
    return {
      fields: [
        {key: 'text', label: 'Question'},
        {key: 'current_value', label: 'Answer'}
      ],
      final_fields: [
        { key: 'property', label: 'Final Microscopy Properties' },
        { key: 'value', label: '' }
      ],
      final_items: [],
      read1: [],
      read2: [],
      read3: [],
      bloodslide_code: null,
      read3_enabled: true,
      case_id: null,
      save_status: false,
      thick_or_thin: null,
      reread_status: false,
      conflict: null,
      qualitative_conflict: null,
      gametocytes_seen_conflict: null
    };
  },
  computed: {},
  mounted: function() {
    let that = this;
    HTTP.get("/kenya/microscopy_qc/"+this.$route.params.case_id).then(response => {
      that.read1 = response.data.read1;
      that.read2 = response.data.read2;
      that.read3 = response.data.read3;
      that.read3_enabled = response.data.read3_enabled;
      that.bloodslide_code = response.data.bloodslide_code;
      that.case_id = response.data.case_id;
      that.thick_or_thin = response.data.thick_or_thin;
      that.final_items.push({
        property: 'Final Parasite Density',
        value: response.data.final_parasite_density
      });
      that.final_items.push({
        property: 'Final Species Identified',
        value: response.data.final_species
      });
    }).catch((error) => {
      HandleErrors.HandleErrors(error);
    });
  },
  watch: {
    read1: {
      handler(){
        this.udpate_final_species();
      },
      deep: true
    },
    read2: {
      handler(){
        this.udpate_final_species();
      },
      deep: true
    },
    read3: {
      handler(){
        this.udpate_final_species();
      },
      deep: true
    }
  },
  methods: {
    reread: function(){
        if(!confirm("Are you sure you want to mark this record as needing to be re-read?  This will reset all values in this microscopy record!")){
          return;
        }
        let that = this;
        that.reread_status = true;

        HTTP.post('/kenya/microscopy_qc/reread/'+that.case_id+'/').then((response) => {
            if(response.data.status == 200){
              alert("This record has been marked for re-read in CommCare.");
              that.reread_status = false;
              this.$router.push({ name: 'microscopy-review-list' });
            }
        }).catch(error => {
          HandleErrors.HandleErrors(error);
        });
    },
     rowClass(item){
       var class_list = '';
       if(item.incorrect && item.type != 'calculated'){
         class_list += 'bg-warning ';
       }
       if(item.type == 'hidden'){
         class_list += 'hidden ';
       }
       return class_list + 'rowHeight';
     },
     find_lowest_distance: function(density_list){
       var current_distance = null;
       var a = null;
       var b = null;

       for(var i = 1; i < density_list.length; i++){
         if(current_distance == null){
           a = parseFloat(density_list[i-1]);
           b = parseFloat(density_list[i]);
           current_distance = Math.abs(b - a);
         }

         var next_distance = Math.abs(parseFloat(density_list[i]) - parseFloat(density_list[i-1]));
         if(next_distance < current_distance){
           a = parseFloat(density_list[i-1]);
           b = parseFloat(density_list[i]);
           current_distance = next_distance;
         }
       }

       // also check the last element and the first
       if(Math.abs(parseFloat(density_list[density_list.length - 1]) - parseFloat(density_list[0])) < current_distance){
         a = parseFloat(density_list[density_list.length - 1]);
         b = parseFloat(density_list[0]);
       }
       return {
         num1: a,
         num2: b
       }

     },
     update_final_density: function(){
       let that = this;
       var read1_density = null;
       var read2_density = null;
       var read3_density = null;
       var i = 0;

       for(i = 0; i < that.read1.length; i++){
         if(that.read1[i].column == 'r1_parasite_density'){
             read1_density = that.read1[i].current_value;
           }
       }
       for(i = 0; i < that.read2.length; i++){
         if(that.read2[i].column == 'r2_parasite_density'){
             read2_density = that.read2[i].current_value;
           }
       }
       for(i = 0; i < that.read3.length; i++){
         if(that.read3[i].column == 'r3_parasite_density'){
             read3_density = that.read3[i].current_value;
           }
       }

        var density_list = [
          read1_density,
          read2_density
        ]
        if(that.read3_enabled){
          density_list.push(read3_density);
        }

        var values = that.find_lowest_distance(density_list);
        
        var final_density = null;
        for(i = 0; i < that.final_items.length; i++){
          if(that.final_items[i].property == 'Final Parasite Density'){
            final_density = that.final_items[i];
          }
        }
        final_density.value = Math.sqrt(values.num1 * values.num2);
     },
     udpate_final_species: function(){
        let that = this;
        that.conflict = null;
        var read1_species = null;
        var read2_species = null;
        var read3_species = null;
        var i = 0;

        for(i = 0; i < that.read1.length; i++){
          if(that.read1[i].column == 'r1_species_identified'){
              if(Array.isArray(that.read1[i].current_value)){
                read1_species = that.read1[i].current_value.join(' ');
              }
              else{
                read1_species = that.read1[i].current_value;
              }
            }
        }
        for(i = 0; i < that.read2.length; i++){
          if(that.read2[i].column == 'r2_species_identified'){
              if(Array.isArray(that.read2[i].current_value)){
                read2_species = that.read2[i].current_value.join(' ');
              }
              else{
                read2_species = that.read2[i].current_value;
              }
            }
        }
        for(i = 0; i < that.read3.length; i++){
          if(that.read3[i].column == 'r3_species_identified'){
              if(Array.isArray(that.read3[i].current_value)){
                read3_species = that.read3[i].current_value.join(' ');
              }
              else{
                read3_species = that.read3[i].current_value;
              }
            }
        }

        var final_answer = null;
        // check read 1 to read 2
        if(read1_species == read2_species){
          final_answer = read1_species;
        }

        // do we have read 3?
        if(that.read3_enabled && ((read1_species == read3_species) || (read2_species == read3_species))){
          final_answer = read3_species;
        }

        // is there a consensus?
        var final_species = null;
        for(i = 0; i < that.final_items.length; i++){
          if(that.final_items[i].property == 'Final Species Identified'){
            final_species = that.final_items[i];
          }
        }
        if(final_answer != null){
          final_species.value = final_answer;
        }
        else{
          final_species.value = 'CONFLICT';
          that.conflict = 'There is an unresolvable conflict on the Species Identified across the available reads.  A re-read is required.';
        }
     },
     update_changes: function(read_variable, prepender){
        // watch for parasite density, if it's there
        this.update_parasite_density(read_variable, prepender);

        // check qualitative results if we need to
        this.check_qualitative();
        this.check_gametocytes();
     },
     check_qualitative: function(){
       let that = this;
       var i = 0;

       // if we only have 2 reads...
       if(!that.read3_enabled){
         // do we have qualitative results to check?
         var qualitative_read1 = null;
         var qualitative_read2 = null;

         for(i = 0; i < that.read1.length; i++){
           if(that.read1[i].column == 'r1_qualitative_result'){
             qualitative_read1 = that.read1[i];
           }
         }

         for(i = 0; i < that.read2.length; i++){
           if(that.read2[i].column == 'r2_qualitative_result'){
             qualitative_read2 = that.read2[i];
           }
         }

         if(qualitative_read1 != null && qualitative_read2 != null){
           if(qualitative_read1.current_value == qualitative_read2.current_value){
              that.qualitative_conflict = null;
           }
           else{
             that.qualitative_conflict = 'There is an unresolvable conflict on the Qualitative Results across Read 1 and Read 2.  A re-read is required.';
           }
         }
       }
     },
     check_gametocytes: function(){
       let that = this;
       var i = 0;

       // if we only have 2 reads...
       if(!that.read3_enabled){
         // do we have qualitative results to check?
         var gametocytes_seen_read1 = null;
         var gametocytes_seen_read2 = null;

         for(i = 0; i < that.read1.length; i++){
           if(that.read1[i].column == 'r1_gametocytes_seen'){
             gametocytes_seen_read1 = that.read1[i];
           }
         }

         for(i = 0; i < that.read2.length; i++){
           if(that.read2[i].column == 'r2_gametocytes_seen'){
             gametocytes_seen_read2 = that.read2[i];
           }
         }

         if(gametocytes_seen_read1 != null && gametocytes_seen_read2 != null){
           if(gametocytes_seen_read1.current_value == gametocytes_seen_read2.current_value){
              that.gametocytes_seen_conflict = null;
           }
           else{
             that.gametocytes_seen_conflict = 'There is an unresolvable conflict on the Gametocytes Seen across Read 1 and Read 2.  A re-read is required.';
           }
         }
       }
     },
     update_parasite_density: function(read_variable, prepender){
       let that = this;
       var i = 0, parasite_density, nap = null;
       // we use different algorithms based on the thick or thin density method used
       if(that.thick_or_thin == 'thin'){
         // find the number of asexual parasites thick variable
         // and the volume of blood
         nap = null;
         var rbc_a = null;
         var rbc_b = null;
         var rbc_calc = null;
         parasite_density = null;
         for(i = 0; i < read_variable.length; i++){
           if(read_variable[i].column == prepender+'number_parasites_counted_thin'){
             nap = read_variable[i];
           }
           if(read_variable[i].column == prepender+'rbc_density_1'){
             rbc_a = read_variable[i];
           }
           if(read_variable[i].column == prepender+'rbc_density_2'){
             rbc_b= read_variable[i];
           }
           if(read_variable[i].column == prepender+'rbc_density_calc'){
             rbc_calc = read_variable[i];
           }
           if(read_variable[i].column == prepender+'parasite_density'){
             parasite_density = read_variable[i];
           }
         }
         // update the parasite density
         rbc_calc.current_value = parseFloat(rbc_a.current_value) * Math.pow(10, parseFloat(rbc_b.current_value));
         parasite_density.current_value = (parseFloat(nap.current_value) * parseFloat(rbc_calc.current_value)) / 2000;
         rbc_calc.incorrect = true;
         parasite_density.incorrect = true;
         
       }
       else{
         // find the number of asexual parasites thick variable
         // and the volume of blood
         nap = null;
         var vob = null;
         parasite_density = null;
         for(i = 0; i < read_variable.length; i++){
           if(read_variable[i].column == prepender+'number_of_asexual_parasites_thick'){
             nap = read_variable[i];
           }
           if(read_variable[i].column == prepender+'volume_of_blood'){
             vob = read_variable[i];
           }
           if(read_variable[i].column == prepender+'parasite_density'){
             parasite_density = read_variable[i];
           }
         }
         // update the parasite density
         parasite_density.current_value = parseFloat(nap.current_value) / (40 * parseFloat(vob.current_value));
         parasite_density.incorrect = true;
       }

       // update the over-all density now
       that.update_final_density();
     },

     save_changes: function(){
        if(!confirm("Are you sure you want to save this data and close this review?")){
          return;
        }
        let that = this;

        // set the save button text
        that.save_status = true;

        const fd = new FormData();
        fd.append('read1', JSON.stringify(that.read1));
        fd.append('read2', JSON.stringify(that.read2));
        fd.append('read3', JSON.stringify(that.read3));
        fd.append('read3_enabled', that.read3_enabled);

        fd.append('case_id', that.case_id);
        fd.append('final_values', JSON.stringify(that.final_items));

        HTTP.post('/kenya/microscopy_qc/'+that.case_id+'/', fd).then((response) => {
            that.save_status = false;
            if(response.data.status == 200){
              alert("Microscopy data saved!");
              this.$router.push({ name: 'microscopy-review-list' });
            }
        }).catch(error => {
          HandleErrors.HandleErrors(error);
        });
     }
  }
};
</script>

<style>
.rowHeight{
  height: 75px;
}

.hidden{
  display: none;
}
</style>